export default {
  next: 'Next',
  resetPassword: 'Reset Password',
  sendEmailRegisteredCode:
    'We will send a Security Code to your registered Email.',
  sendPhoneRegisteredCode:
    'We will send a verification code to your registered Phone.',
  labelRegisteredEmail: 'Please enter your registered Email',
  labelRegisteredPhone: 'Please enter your phone number',
  enterEmail: 'Enter your email',
  enterMobilePhone: 'Phone number',
  validEmail: 'Wrong email',
  validPhone: 'Wrong phone number',
  verificationCode: 'Verification code',
  enterNewPassword: 'Enter new password',
  reEnterNewPassowrd: 'Re-enter new password',
  ruleEmail: 'Please enter your email',
  ruleMobilePhone: 'Please enter your phone number',
  labelCode: 'Please enter Security',
  noMatchPassword: 'Passwords do not match',
  showPasswordRules:
    'Password must be at least 8 characters long and contain at least a letter',
}
